/*
 * URDILE TOAST
 * Sistema global de notificaciones (success / warning / danger).
 * API:
 *   UrdileToast.show({ type, message, duration })
 *   UrdileToast.success(message, duration?)
 *   UrdileToast.warning(message, duration?)
 *   UrdileToast.danger(message, duration?)
 *   UrdileToast.dismissAll()
 */
(function() {
  'use strict';

  var ICONS = {
    success: '<i class="fa-solid fa-circle-check" aria-hidden="true"></i>',
    warning: '<i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>',
    danger:  '<i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>'
  };

  function getContainer() {
    return document.getElementById('ToastContainer');
  }

  function show(opts) {
    opts = opts || {};
    var type = opts.type || 'success';
    if (!ICONS[type]) type = 'success';
    var message = opts.message || '';
    var duration = (opts.duration === 0) ? 0 : (opts.duration || 3500);

    var container = getContainer();
    if (!container) {
      console.warn('UrdileToast: ToastContainer no encontrado.');
      return null;
    }

    var template = document.getElementById('ToastTemplate');
    var toast;
    if (template && template.content && template.content.firstElementChild) {
      toast = template.content.firstElementChild.cloneNode(true);
    } else {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'status');
      toast.innerHTML =
        '<span class="toast__icon"></span>' +
        '<span class="toast__message"></span>' +
        '<button type="button" class="toast__close" aria-label="Cerrar">×</button>';
    }

    toast.classList.add('toast--' + type);
    var iconEl = toast.querySelector('.toast__icon');
    var msgEl = toast.querySelector('.toast__message');
    var closeBtn = toast.querySelector('.toast__close');

    if (iconEl) iconEl.innerHTML = ICONS[type];
    if (msgEl) msgEl.textContent = message;

    var dismissTimer = null;

    function dismiss() {
      if (dismissTimer) { clearTimeout(dismissTimer); dismissTimer = null; }
      toast.classList.add('toast--leaving');
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 250);
    }

    if (closeBtn) closeBtn.addEventListener('click', dismiss);

    container.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('toast--visible');
    });

    if (duration > 0) {
      dismissTimer = setTimeout(dismiss, duration);
    }

    toast.addEventListener('mouseenter', function() {
      if (dismissTimer) { clearTimeout(dismissTimer); dismissTimer = null; }
    });
    toast.addEventListener('mouseleave', function() {
      if (duration > 0) {
        dismissTimer = setTimeout(dismiss, 1500);
      }
    });

    return { dismiss: dismiss, element: toast };
  }

  function dismissAll() {
    var container = getContainer();
    if (!container) return;
    container.querySelectorAll('.toast').forEach(function(t) {
      t.classList.add('toast--leaving');
      setTimeout(function() {
        if (t.parentNode) t.parentNode.removeChild(t);
      }, 250);
    });
  }

  window.UrdileToast = {
    show: show,
    success: function(m, d) { return show({ type: 'success', message: m, duration: d }); },
    warning: function(m, d) { return show({ type: 'warning', message: m, duration: d }); },
    danger:  function(m, d) { return show({ type: 'danger',  message: m, duration: d }); },
    dismissAll: dismissAll
  };
})();
